module.exports = __webpack_public_path__ + "img/2H.6c142beb.svg";